import type { FaireThemeEntity } from "../../entity_types/theme";

export const discovery_theme_cocktail_hour: FaireThemeEntity = {
  token: "discovery_theme_cocktail-hour",
  type: "theme",
  retailerToken: "r_discovery",
  name: "Cocktail Hour Essentials",
  description: "Bar tools and accessories for entertaining",
  bgColor: "#F5E8D0",
  productTokens: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
